export default __webpack_public_path__ + "static/media/the-emperor@2x.cacf1484.png";